module.exports = __webpack_public_path__ + "img/eC_Direct_icon.16f17c31.png";